export enum AborCities {
  Academy = 'academy',
  Adamsville = 'adamsville',
  Adina = 'adina',
  Airville = 'airville',
  Albert = 'albert',
  Algreita = 'algreita',
  AlumCreek = 'alumCreek',
  Ammansville = 'ammansville',
  Andice = 'andice',
  Austin = 'austin',
  Balcones = 'balcones',
  Bankersmith = 'bankersmith',
  Barbarosa = 'barbarosa',
  Bartlett = 'bartlett',
  Bastrop = 'bastrop',
  Bateman = 'bateman',
  BeasleyCrossing = 'beasleyCrossing',
  Beaukiss = 'beaukiss',
  Bebe = 'bebe',
  BeeCave = 'beeCave',
  Belco = 'belco',
  Belfalls = 'belfalls',
  Belmont = 'belmont',
  Belton = 'belton',
  BenArnold = 'benArnold',
  Bend = 'bend',
  Bertram = 'bertram',
  Bexas = 'bexas',
  Beyersville = 'beyersville',
  Blanco = 'blanco',
  Bland = 'bland',
  Blowout = 'blowout',
  Blue = 'blue',
  BluffSprings = 'bluffSprings',
  Bluffton = 'bluffton',
  Blumenthal = 'blumenthal',
  Boardhouse = 'boardhouse',
  Bowser = 'bowser',
  Bracken = 'bracken',
  Branchville = 'branchville',
  Briarcliff = 'briarcliff',
  Briary = 'briary',
  Briggs = 'briggs',
  Brookhaven = 'brookhaven',
  BrooksCrossing = 'brooksCrossing',
  Brownboro = 'brownboro',
  BuchananDam = 'buchananDam',
  Buckholts = 'buckholts',
  Buda = 'buda',
  BuffaloGap = 'buffaloGap',
  Bulverde = 'bulverde',
  Burlington = 'burlington',
  Burnet = 'burnet',
  Butler = 'butler',
  CainCity = 'cainCity',
  Calvin = 'calvin',
  Cameron = 'cameron',
  CampWillow = 'campWillow',
  CanyonLake = 'canyonLake',
  Carlson = 'carlson',
  Carmine = 'carmine',
  Castell = 'castell',
  CedarCreek = 'cedarCreek',
  CedarPark = 'cedarPark',
  CedarValley = 'cedarValley',
  Cele = 'cele',
  ChaffeeVillage = 'chaffeeVillage',
  Chappel = 'chappel',
  Cherokee = 'cherokee',
  CherryMountain = 'cherryMountain',
  CherrySpring = 'cherrySpring',
  ChinaCreek = 'chinaCreek',
  Cibolo = 'cibolo',
  Circleville = 'circleville',
  Cistern = 'cistern',
  ClearSprings = 'clearSprings',
  Clearview = 'clearview',
  Click = 'click',
  ColdSprings = 'coldSprings',
  Colton = 'colton',
  Comal = 'comal',
  CopperasCove = 'copperasCove',
  CornHill = 'cornHill',
  CottonwoodShores = 'cottonwoodShores',
  Coupland = 'coupland',
  Crabapple = 'crabapple',
  Creedmoor = 'creedmoor',
  Crossroads = 'crossroads',
  CurryCrossing = 'curryCrossing',
  Cyclone = 'cyclone',
  CypressMill = 'cypressMill',
  Daffen = 'daffen',
  Dale = 'dale',
  Davilla = 'davilla',
  DelValle = 'delValle',
  Delhi = 'delhi',
  Demarco = 'demarco',
  Dessau = 'dessau',
  Detmold = 'detmold',
  Dilworth = 'dilworth',
  DimeBox = 'dimeBox',
  DingDong = 'dingDong',
  DoakSprings = 'doakSprings',
  DogRidge = 'dogRidge',
  Donahoe = 'donahoe',
  Doss = 'doss',
  DoubleFord = 'doubleFord',
  Driftwood = 'driftwood',
  DrippingSprings = 'drippingSprings',
  Dubina = 'dubina',
  Dugger = 'dugger',
  Dunlap = 'dunlap',
  Eckert = 'eckert',
  EdgewaterBeach = 'edgewaterBeach',
  Edgeworth = 'edgeworth',
  Elevation = 'elevation',
  Elgin = 'elgin',
  Ellinger = 'ellinger',
  ElmGrove = 'elmGrove',
  Elroy = 'elroy',
  Engle = 'engle',
  Euland = 'euland',
  Evant = 'evant',
  Fairland = 'fairland',
  Fairview = 'fairview',
  FaubionCrossing = 'faubionCrossing',
  Fayetteville = 'fayetteville',
  Fedor = 'fedor',
  Fentress = 'fentress',
  FieldCreek = 'fieldCreek',
  Fischer = 'fischer',
  Fitzhugh = 'fitzhugh',
  Flatonia = 'flatonia',
  Florence = 'florence',
  Floy = 'floy',
  Flugrath = 'flugrath',
  ForisterRanch = 'foristerRanch',
  FortHood = 'fortHood',
  FourPoints = 'fourPoints',
  Fredericksburg = 'fredericksburg',
  Fredonia = 'fredonia',
  Freiheit = 'freiheit',
  Freyburg = 'freyburg',
  FriendlyCorner = 'friendlyCorner',
  Gainesville = 'gainesville',
  Galle = 'galle',
  Gano = 'gano',
  GardenRidge = 'gardenRidge',
  Garfield = 'garfield',
  Gatesville = 'gatesville',
  Gause = 'gause',
  Georgetown = 'georgetown',
  Geronimo = 'geronimo',
  Giddings = 'giddings',
  Glecker = 'glecker',
  Gober = 'gober',
  Gold = 'gold',
  Gonzales = 'gonzales',
  Granger = 'granger',
  GraniteShoals = 'graniteShoals',
  Grapetown = 'grapetown',
  GreensCrossing = 'greensCrossing',
  Gregg = 'gregg',
  Gruene = 'gruene',
  Haeckerville = 'haeckerville',
  Hall = 'hall',
  HallmarkCrossing = 'hallmarkCrossing',
  Halsted = 'halsted',
  HammettsCrossing = 'hammettsCrossing',
  Hanover = 'hanover',
  Hare = 'hare',
  HarkerHeights = 'harkerHeights',
  Harkeyville = 'harkeyville',
  Harper = 'harper',
  Harwood = 'harwood',
  Haven = 'haven',
  Hays = 'hays',
  Heidenheimer = 'heidenheimer',
  Henly = 'henly',
  Hicks = 'hicks',
  HighHill = 'highHill',
  HighValley = 'highValley',
  Highland = 'highland',
  HighlandHaven = 'highlandHaven',
  HildaSiding = 'hildaSiding',
  HillHills = 'hillHills',
  Hilltop = 'hilltop',
  Hobbs = 'hobbs',
  Holland = 'holland',
  Holman = 'holman',
  Holt = 'holt',
  HornsbyBend = 'hornsbyBend',
  HorseshoeBay = 'horseshoeBay',
  Hoxie = 'hoxie',
  Hoyte = 'hoyte',
  HudsonBend = 'hudsonBend',
  HuntCrossing = 'huntCrossing',
  Hunter = 'hunter',
  Hutto = 'hutto',
  Hye = 'hye',
  InksLakeVillage = 'inksLakeVillage',
  Izoro = 'izoro',
  Jarrell = 'jarrell',
  Jeddo = 'jeddo',
  JinksBranch = 'jinksBranch',
  JohnsonCity = 'johnsonCity',
  Joliet = 'joliet',
  Jollyville = 'jollyville',
  Jonah = 'jonah',
  JonesPrairie = 'jonesPrairie',
  Jonestown = 'jonestown',
  Joppa = 'joppa',
  JubileeSprings = 'jubileeSprings',
  KayBeeHeights = 'kayBeeHeights',
  Keelersville = 'keelersville',
  Kempner = 'kempner',
  Kendalia = 'kendalia',
  KeysCrossing = 'keysCrossing',
  Killeen = 'killeen',
  Kimbro = 'kimbro',
  KingsVillage = 'kingsVillage',
  Kingsbury = 'kingsbury',
  Kingsland = 'kingsland',
  Kirtley = 'kirtley',
  KnobbSprings = 'knobbSprings',
  Knoxvill = 'knoxvill',
  Kovar = 'kovar',
  Kyle = 'kyle',
  LaGrange = 'laGrange',
  LaVernia = 'laVernia',
  LagoVista = 'lagoVista',
  LakeDunlap = 'lakeDunlap',
  LakeShores = 'lakeShores',
  LakeVictor = 'lakeVictor',
  LakesideHeights = 'lakesideHeights',
  Lakeway = 'lakeway',
  Lampasas = 'lampasas',
  Laneport = 'laneport',
  Lauback = 'lauback',
  Leander = 'leander',
  Ledbetter = 'ledbetter',
  Leedale = 'leedale',
  Leesville = 'leesville',
  Leo = 'leo',
  LeonValley = 'leonValley',
  Lexington = 'lexington',
  LibertyHill = 'libertyHill',
  Lilac = 'lilac',
  Lincoln = 'lincoln',
  Littig = 'littig',
  LittleRiverAcademy = 'littleRiverAcademy',
  Llano = 'llano',
  Locker = 'locker',
  Lockhart = 'lockhart',
  Loebau = 'loebau',
  Lometa = 'lometa',
  LoneGrove = 'loneGrove',
  LoneStar = 'loneStar',
  Luckenbach = 'luckenbach',
  Luling = 'luling',
  Lund = 'lund',
  LyttonSprings = 'lyttonSprings',
  Maha = 'maha',
  Mahomet = 'mahomet',
  Manchaca = 'manchaca',
  Manda = 'manda',
  Manheim = 'manheim',
  Manor = 'manor',
  MarbleFalls = 'marbleFalls',
  Marion = 'marion',
  Marjorie = 'marjorie',
  MarshallFord = 'marshallFord',
  Martindale = 'martindale',
  Maurin = 'maurin',
  Maxdale = 'maxdale',
  Maxwell = 'maxwell',
  Maysfield = 'maysfield',
  McDade = 'mcDade',
  McMahan = 'mcMahan',
  McMillan = 'mcMillan',
  McNairVillage = 'mcNairVillage',
  McNeil = 'mcNeil',
  McQueeney = 'mcQueeney',
  MeadorGrove = 'meadorGrove',
  Meadowlakes = 'meadowlakes',
  Meeks = 'meeks',
  Mendoza = 'mendoza',
  Merrelltown = 'merrelltown',
  Midway = 'midway',
  Milano = 'milano',
  Milburn = 'milburn',
  Minerva = 'minerva',
  Moffat = 'moffat',
  Moline = 'moline',
  Montopolis = 'montopolis',
  Moody = 'moody',
  MooresCrossing = 'mooresCrossing',
  Moravia = 'moravia',
  MorgansPointResort = 'morgansPointResort',
  MorrisFalls = 'morrisFalls',
  MorrisRanch = 'morrisRanch',
  Moulton = 'moulton',
  MountainCity = 'mountainCity',
  MountySharp = 'mountySharp',
  Mozo = 'mozo',
  MtGainor = 'mtGainor',
  Muehlsville = 'muehlsville',
  Muldoon = 'muldoon',
  MullinsPrairie = 'mullinsPrairie',
  MustangRidge = 'mustangRidge',
  Naruna = 'naruna',
  Nassau = 'nassau',
  Nechanitz = 'nechanitz',
  Needa = 'needa',
  NewBerlin = 'newBerlin',
  NewBraunfels = 'newBraunfels',
  NewClarkson = 'newClarkson',
  NewColony = 'newColony',
  NewCornHill = 'newCornHill',
  NewKaty = 'newKaty',
  NewSweden = 'newSweden',
  Nickel = 'nickel',
  Niederwald = 'niederwald',
  Nile = 'nile',
  Nix = 'nix',
  Nixon = 'nixon',
  Noack = 'noack',
  Nolanville = 'nolanville',
  Nolte = 'nolte',
  NormansCrossing = 'normansCrossing',
  Northcliff = 'northcliff',
  Northrup = 'northrup',
  Noxvill = 'noxvill',
  OakForest = 'oakForest',
  OakHill = 'oakHill',
  Oakalla = 'oakalla',
  Oatmeal = 'oatmeal',
  Ocker = 'ocker',
  Oenaville = 'oenaville',
  Ogden = 'ogden',
  OldDimeBox = 'oldDimeBox',
  Oldenburg = 'oldenburg',
  Olmos = 'olmos',
  Oquinn = 'oquinn',
  Oscar = 'oscar',
  Other = 'other',
  Ottine = 'ottine',
  OwlCreek = 'owlCreek',
  Paige = 'paige',
  Payton = 'payton',
  PecanSprings = 'pecanSprings',
  Pendleton = 'pendleton',
  Pettibone = 'pettibone',
  Pettytown = 'pettytown',
  Pflugerville = 'pflugerville',
  Phelan = 'phelan',
  PilotKnob = 'pilotKnob',
  PioneerTown = 'pioneerTown',
  PleasantValley = 'pleasantValley',
  Plum = 'plum',
  PointVenture = 'pointVenture',
  Pontotoc = 'pontotoc',
  PostOak = 'postOak',
  Praesel = 'praesel',
  PrahaRabbsPrairie = 'prahaRabbsPrairie',
  PrairieDell = 'prairieDell',
  PrairieLea = 'prairieLea',
  PrairieMountain = 'prairieMountain',
  RadioJunction = 'radioJunction',
  Ratibor = 'ratibor',
  Ratler = 'ratler',
  RedBluffCrossing = 'redBluffCrossing',
  RedRanger = 'redRanger',
  RedRock = 'redRock',
  Redwood = 'redwood',
  Reedville = 'reedville',
  RiceSchoolCrossing = 'riceSchoolCrossing',
  RicesCrossing = 'ricesCrossing',
  RichlandSprings = 'richlandSprings',
  RiggsFord = 'riggsFord',
  RiversHill = 'riversHill',
  Rochelle = 'rochelle',
  Rockdale = 'rockdale',
  Rockne = 'rockne',
  RockyCreek = 'rockyCreek',
  RockyHill = 'rockyHill',
  Rogers = 'rogers',
  Rollingwood = 'rollingwood',
  Rosanky = 'rosanky',
  Rosebud = 'rosebud',
  RoughCreekCrossing = 'roughCreekCrossing',
  RoundMountain = 'roundMountain',
  RoundRock = 'roundRock',
  RoundTop = 'roundTop',
  Rumley = 'rumley',
  Rutersville = 'rutersville',
  Salado = 'salado',
  Salty = 'salty',
  SanAntonio = 'sanAntonio',
  SanGabriel = 'sanGabriel',
  SanLeanna = 'sanLeanna',
  SanMarcos = 'sanMarcos',
  SanSaba = 'sanSaba',
  Sandoval = 'sandoval',
  Sandow = 'sandow',
  Sandy = 'sandy',
  SandyCreek = 'sandyCreek',
  SandyFork = 'sandyFork',
  SantaClara = 'santaClara',
  Sattle = 'sattle',
  Saturn = 'saturn',
  Sayersville = 'sayersville',
  Schertz = 'schertz',
  Schulenburg = 'schulenburg',
  Schumannsville = 'schumannsville',
  Schwertner = 'schwertner',
  Scobee = 'scobee',
  ScottsCrossing = 'scottsCrossing',
  Seaton = 'seaton',
  Seawillow = 'seawillow',
  Seguin = 'seguin',
  Selma = 'selma',
  Selman = 'selman',
  Senterfitt = 'senterfitt',
  Serbin = 'serbin',
  SewardJunction = 'sewardJunction',
  ShadyGrove = 'shadyGrove',
  Sharp = 'sharp',
  Shelby = 'shelby',
  SherwoodShores = 'sherwoodShores',
  Shortall = 'shortall',
  Siloam = 'siloam',
  SilverCity = 'silverCity',
  Skeeterville = 'skeeterville',
  Skyview = 'skyview',
  Sloan = 'sloan',
  Smiley = 'smiley',
  Smithville = 'smithville',
  Smithwick = 'smithwick',
  SodaSprings = 'sodaSprings',
  Solms = 'solms',
  SommersMill = 'sommersMill',
  SouthElm = 'southElm',
  SouthJonestownHills = 'southJonestownHills',
  Sparks = 'sparks',
  SparksCrossing = 'sparksCrossing',
  Spicewood = 'spicewood',
  SpringBranch = 'springBranch',
  SpringCreek = 'springCreek',
  Sprinkle = 'sprinkle',
  StJohnColony = 'stJohnColony',
  Stairtown = 'stairtown',
  Stampede = 'stampede',
  Staples = 'staples',
  Startzville = 'startzville',
  Stellar = 'stellar',
  Stolz = 'stolz',
  Stonewall = 'stonewall',
  StringPrairie = 'stringPrairie',
  Stringtown = 'stringtown',
  Structure = 'structure',
  Sudduth = 'sudduth',
  Summerville = 'summerville',
  Sunnyland = 'sunnyland',
  SunriseBeach = 'sunriseBeach',
  SunsetValley = 'sunsetValley',
  SweetHome = 'sweetHome',
  Tanglewood = 'tanglewood',
  Tarrytown = 'tarrytown',
  Taylor = 'taylor',
  Taylorsville = 'taylorsville',
  Temple = 'temple',
  TheGrove = 'theGrove',
  TheHills = 'theHills',
  Theon = 'theon',
  Thompsonville = 'thompsonville',
  Thorndale = 'thorndale',
  Thrall = 'thrall',
  ThreePoints = 'threePoints',
  Tilmon = 'tilmon',
  Tivydale = 'tivydale',
  Togo = 'togo',
  Topsey = 'topsey',
  Tow = 'tow',
  Tracy = 'tracy',
  TravisHeights = 'travisHeights',
  Troy = 'troy',
  Tunis = 'tunis',
  Turnersville = 'turnersville',
  TwinSisters = 'twinSisters',
  Type = 'type',
  Uhland = 'uhland',
  UnionHill = 'unionHill',
  Upton = 'upton',
  Utley = 'utley',
  ValVerde = 'valVerde',
  ValleySpring = 'valleySpring',
  Vilas = 'vilas',
  VillageofBearCreek = 'villageofBearCreek',
  VillageoftheHills = 'villageoftheHills',
  Volente = 'volente',
  Waelder = 'waelder',
  Walburg = 'walburg',
  Waldeck = 'waldeck',
  Walhalla = 'walhalla',
  WalkerVillage = 'walkerVillage',
  Walkerton = 'walkerton',
  WardSpring = 'wardSpring',
  Warda = 'warda',
  Warrenton = 'warrenton',
  Waterloo = 'waterloo',
  Watson = 'watson',
  Watterson = 'watterson',
  Webberville = 'webberville',
  Weinert = 'weinert',
  Weir = 'weir',
  WestCliff = 'westCliff',
  WestLakeHills = 'westLakeHills',
  WestPoint = 'westPoint',
  WhiteHall = 'whiteHall',
  Whitestone = 'whitestone',
  Willman = 'willman',
  WillowCity = 'willowCity',
  Wimberley = 'wimberley',
  Winchester = 'winchester',
  Woodcreek = 'woodcreek',
  Woodland = 'woodland',
  WuthrichHill = 'wuthrichHill',
  Yarrelton = 'yarrelton',
  Youngsport = 'youngsport',
  Zabcikville = 'zabcikville',
  Zipp = 'zipp',
  Zorn = 'zorn',
  Zuehl = 'zuehl'
}

export const AborCitiesLabel: Record<AborCities, string> = {
  [AborCities.Academy]: 'Academy',
  [AborCities.Adamsville]: 'Adamsville',
  [AborCities.Adina]: 'Adina',
  [AborCities.Airville]: 'Airville',
  [AborCities.Albert]: 'Albert',
  [AborCities.Algreita]: 'Algreita',
  [AborCities.AlumCreek]: 'Alum Creek',
  [AborCities.Ammansville]: 'Ammansville',
  [AborCities.Andice]: 'Andice',
  [AborCities.Austin]: 'Austin',
  [AborCities.Balcones]: 'Balcones',
  [AborCities.Bankersmith]: 'Bankersmith',
  [AborCities.Barbarosa]: 'Barbarosa',
  [AborCities.Bartlett]: 'Bartlett',
  [AborCities.Bastrop]: 'Bastrop',
  [AborCities.Bateman]: 'Bateman',
  [AborCities.BeasleyCrossing]: 'Beasley Crossing',
  [AborCities.Beaukiss]: 'Beaukiss',
  [AborCities.Bebe]: 'Bebe',
  [AborCities.BeeCave]: 'Bee Cave',
  [AborCities.Belco]: 'Belco',
  [AborCities.Belfalls]: 'Belfalls',
  [AborCities.Belmont]: 'Belmont',
  [AborCities.Belton]: 'Belton',
  [AborCities.BenArnold]: 'Ben Arnold',
  [AborCities.Bend]: 'Bend',
  [AborCities.Bertram]: 'Bertram',
  [AborCities.Bexas]: 'Bexas',
  [AborCities.Beyersville]: 'Beyersville',
  [AborCities.Blanco]: 'Blanco',
  [AborCities.Bland]: 'Bland',
  [AborCities.Blowout]: 'Blowout',
  [AborCities.Blue]: 'Blue',
  [AborCities.BluffSprings]: 'Bluff Springs',
  [AborCities.Bluffton]: 'Bluffton',
  [AborCities.Blumenthal]: 'Blumenthal',
  [AborCities.Boardhouse]: 'Boardhouse',
  [AborCities.Bowser]: 'Bowser',
  [AborCities.Bracken]: 'Bracken',
  [AborCities.Branchville]: 'Branchville',
  [AborCities.Briarcliff]: 'Briarcliff',
  [AborCities.Briary]: 'Briary',
  [AborCities.Briggs]: 'Briggs',
  [AborCities.Brookhaven]: 'Brookhaven',
  [AborCities.BrooksCrossing]: 'Brooks Crossing',
  [AborCities.Brownboro]: 'Brownboro',
  [AborCities.BuchananDam]: 'Buchanan Dam',
  [AborCities.Buckholts]: 'Buckholts',
  [AborCities.Buda]: 'Buda',
  [AborCities.BuffaloGap]: 'Buffalo Gap',
  [AborCities.Bulverde]: 'Bulverde',
  [AborCities.Burlington]: 'Burlington',
  [AborCities.Burnet]: 'Burnet',
  [AborCities.Butler]: 'Butler',
  [AborCities.CainCity]: 'Cain City',
  [AborCities.Calvin]: 'Calvin',
  [AborCities.Cameron]: 'Cameron',
  [AborCities.CampWillow]: 'Camp Willow',
  [AborCities.CanyonLake]: 'Canyon Lake',
  [AborCities.Carlson]: 'Carlson',
  [AborCities.Carmine]: 'Carmine',
  [AborCities.Castell]: 'Castell',
  [AborCities.CedarCreek]: 'Cedar Creek',
  [AborCities.CedarPark]: 'Cedar Park',
  [AborCities.CedarValley]: 'Cedar Valley',
  [AborCities.Cele]: 'Cele',
  [AborCities.ChaffeeVillage]: 'Chaffee Village',
  [AborCities.Chappel]: 'Chappel',
  [AborCities.Cherokee]: 'Cherokee',
  [AborCities.CherryMountain]: 'Cherry Mountain',
  [AborCities.CherrySpring]: 'Cherry Spring',
  [AborCities.ChinaCreek]: 'China Creek',
  [AborCities.Cibolo]: 'Cibolo',
  [AborCities.Circleville]: 'Circleville',
  [AborCities.Cistern]: 'Cistern',
  [AborCities.ClearSprings]: 'Clear Springs',
  [AborCities.Clearview]: 'Clearview',
  [AborCities.Click]: 'Click',
  [AborCities.ColdSprings]: 'Cold Springs',
  [AborCities.Colton]: 'Colton',
  [AborCities.Comal]: 'Comal',
  [AborCities.CopperasCove]: 'Copperas Cove',
  [AborCities.CornHill]: 'Corn Hill',
  [AborCities.CottonwoodShores]: 'Cottonwood Shores',
  [AborCities.Coupland]: 'Coupland',
  [AborCities.Crabapple]: 'Crabapple',
  [AborCities.Creedmoor]: 'Creedmoor',
  [AborCities.Crossroads]: 'Crossroads',
  [AborCities.CurryCrossing]: 'Curry Crossing',
  [AborCities.Cyclone]: 'Cyclone',
  [AborCities.CypressMill]: 'Cypress Mill',
  [AborCities.Daffen]: 'Daffen',
  [AborCities.Dale]: 'Dale',
  [AborCities.Davilla]: 'Davilla',
  [AborCities.DelValle]: 'Del Valle',
  [AborCities.Delhi]: 'Delhi',
  [AborCities.Demarco]: 'Demarco',
  [AborCities.Dessau]: 'Dessau',
  [AborCities.Detmold]: 'Detmold',
  [AborCities.Dilworth]: 'Dilworth',
  [AborCities.DimeBox]: 'Dime Box',
  [AborCities.DingDong]: 'Ding Dong',
  [AborCities.DoakSprings]: 'Doak Springs',
  [AborCities.DogRidge]: 'Dog Ridge',
  [AborCities.Donahoe]: 'Donahoe',
  [AborCities.Doss]: 'Doss',
  [AborCities.DoubleFord]: 'Double Ford',
  [AborCities.Driftwood]: 'Driftwood',
  [AborCities.DrippingSprings]: 'Dripping Springs',
  [AborCities.Dubina]: 'Dubina',
  [AborCities.Dugger]: 'Dugger',
  [AborCities.Dunlap]: 'Dunlap',
  [AborCities.Eckert]: 'Eckert',
  [AborCities.EdgewaterBeach]: 'Edgewater Beach',
  [AborCities.Edgeworth]: 'Edgeworth',
  [AborCities.Elevation]: 'Elevation',
  [AborCities.Elgin]: 'Elgin',
  [AborCities.Ellinger]: 'Ellinger',
  [AborCities.ElmGrove]: 'Elm Grove',
  [AborCities.Elroy]: 'Elroy',
  [AborCities.Engle]: 'Engle',
  [AborCities.Euland]: 'Euland',
  [AborCities.Evant]: 'Evant',
  [AborCities.Fairland]: 'Fairland',
  [AborCities.Fairview]: 'Fairview',
  [AborCities.FaubionCrossing]: 'Faubion Crossing',
  [AborCities.Fayetteville]: 'Fayetteville',
  [AborCities.Fedor]: 'Fedor',
  [AborCities.Fentress]: 'Fentress',
  [AborCities.FieldCreek]: 'Field Creek',
  [AborCities.Fischer]: 'Fischer',
  [AborCities.Fitzhugh]: 'Fitzhugh',
  [AborCities.Flatonia]: 'Flatonia',
  [AborCities.Florence]: 'Florence',
  [AborCities.Floy]: 'Floy',
  [AborCities.Flugrath]: 'Flugrath',
  [AborCities.ForisterRanch]: 'Forister Ranch',
  [AborCities.FortHood]: 'Fort Hood',
  [AborCities.FourPoints]: 'Four Points',
  [AborCities.Fredericksburg]: 'Fredericksburg',
  [AborCities.Fredonia]: 'Fredonia',
  [AborCities.Freiheit]: 'Freiheit',
  [AborCities.Freyburg]: 'Freyburg',
  [AborCities.FriendlyCorner]: 'Friendly Corner',
  [AborCities.Gainesville]: 'Gainesville',
  [AborCities.Galle]: 'Galle',
  [AborCities.Gano]: 'Gano',
  [AborCities.GardenRidge]: 'Garden Ridge',
  [AborCities.Garfield]: 'Garfield',
  [AborCities.Gatesville]: 'Gatesville',
  [AborCities.Gause]: 'Gause',
  [AborCities.Georgetown]: 'Georgetown',
  [AborCities.Geronimo]: 'Geronimo',
  [AborCities.Giddings]: 'Giddings',
  [AborCities.Glecker]: 'Glecker',
  [AborCities.Gober]: 'Gober',
  [AborCities.Gold]: 'Gold',
  [AborCities.Gonzales]: 'Gonzales',
  [AborCities.Granger]: 'Granger',
  [AborCities.GraniteShoals]: 'Granite Shoals',
  [AborCities.Grapetown]: 'Grapetown',
  [AborCities.GreensCrossing]: 'Greens Crossing',
  [AborCities.Gregg]: 'Gregg',
  [AborCities.Gruene]: 'Gruene',
  [AborCities.Haeckerville]: 'Haeckerville',
  [AborCities.Hall]: 'Hall',
  [AborCities.HallmarkCrossing]: 'Hallmark Crossing',
  [AborCities.Halsted]: 'Halsted',
  [AborCities.HammettsCrossing]: 'Hammetts Crossing',
  [AborCities.Hanover]: 'Hanover',
  [AborCities.Hare]: 'Hare',
  [AborCities.HarkerHeights]: 'Harker Heights',
  [AborCities.Harkeyville]: 'Harkeyville',
  [AborCities.Harper]: 'Harper',
  [AborCities.Harwood]: 'Harwood',
  [AborCities.Haven]: 'Haven',
  [AborCities.Hays]: 'Hays',
  [AborCities.Heidenheimer]: 'Heidenheimer',
  [AborCities.Henly]: 'Henly',
  [AborCities.Hicks]: 'Hicks',
  [AborCities.HighHill]: 'High Hill',
  [AborCities.HighValley]: 'High Valley',
  [AborCities.Highland]: 'Highland',
  [AborCities.HighlandHaven]: 'Highland Haven',
  [AborCities.HildaSiding]: 'Hilda Siding',
  [AborCities.HillHills]: 'Hill Hills',
  [AborCities.Hilltop]: 'Hilltop',
  [AborCities.Hobbs]: 'Hobbs',
  [AborCities.Holland]: 'Holland',
  [AborCities.Holman]: 'Holman',
  [AborCities.Holt]: 'Holt',
  [AborCities.HornsbyBend]: 'Hornsby Bend',
  [AborCities.HorseshoeBay]: 'Horseshoe Bay',
  [AborCities.Hoxie]: 'Hoxie',
  [AborCities.Hoyte]: 'Hoyte',
  [AborCities.HudsonBend]: 'Hudson Bend',
  [AborCities.HuntCrossing]: 'Hunt Crossing',
  [AborCities.Hunter]: 'Hunter',
  [AborCities.Hutto]: 'Hutto',
  [AborCities.Hye]: 'Hye',
  [AborCities.InksLakeVillage]: 'Inks Lake Village',
  [AborCities.Izoro]: 'Izoro',
  [AborCities.Jarrell]: 'Jarrell',
  [AborCities.Jeddo]: 'Jeddo',
  [AborCities.JinksBranch]: 'Jinks Branch',
  [AborCities.JohnsonCity]: 'Johnson City',
  [AborCities.Joliet]: 'Joliet',
  [AborCities.Jollyville]: 'Jollyville',
  [AborCities.Jonah]: 'Jonah',
  [AborCities.JonesPrairie]: 'Jones Prairie',
  [AborCities.Jonestown]: 'Jonestown',
  [AborCities.Joppa]: 'Joppa',
  [AborCities.JubileeSprings]: 'Jubilee Springs',
  [AborCities.KayBeeHeights]: 'Kay Bee Heights',
  [AborCities.Keelersville]: 'Keelersville',
  [AborCities.Kempner]: 'Kempner',
  [AborCities.Kendalia]: 'Kendalia',
  [AborCities.KeysCrossing]: 'Keys Crossing',
  [AborCities.Killeen]: 'Killeen',
  [AborCities.Kimbro]: 'Kimbro',
  [AborCities.KingsVillage]: 'Kings Village',
  [AborCities.Kingsbury]: 'Kingsbury',
  [AborCities.Kingsland]: 'Kingsland',
  [AborCities.Kirtley]: 'Kirtley',
  [AborCities.KnobbSprings]: 'Knobb Springs',
  [AborCities.Knoxvill]: 'Knoxvill',
  [AborCities.Kovar]: 'Kovar',
  [AborCities.Kyle]: 'Kyle',
  [AborCities.LaGrange]: 'La Grange',
  [AborCities.LaVernia]: 'La Vernia',
  [AborCities.LagoVista]: 'Lago Vista',
  [AborCities.LakeDunlap]: 'Lake Dunlap',
  [AborCities.LakeShores]: 'Lake Shores',
  [AborCities.LakeVictor]: 'Lake Victor',
  [AborCities.LakesideHeights]: 'Lakeside Heights',
  [AborCities.Lakeway]: 'Lakeway',
  [AborCities.Lampasas]: 'Lampasas',
  [AborCities.Laneport]: 'Laneport',
  [AborCities.Lauback]: 'Lauback',
  [AborCities.Leander]: 'Leander',
  [AborCities.Ledbetter]: 'Ledbetter',
  [AborCities.Leedale]: 'Leedale',
  [AborCities.Leesville]: 'Leesville',
  [AborCities.Leo]: 'Leo',
  [AborCities.LeonValley]: 'Leon Valley',
  [AborCities.Lexington]: 'Lexington',
  [AborCities.LibertyHill]: 'Liberty Hill',
  [AborCities.Lilac]: 'Lilac',
  [AborCities.Lincoln]: 'Lincoln',
  [AborCities.Littig]: 'Littig',
  [AborCities.LittleRiverAcademy]: 'Little River-Academy',
  [AborCities.Llano]: 'Llano',
  [AborCities.Locker]: 'Locker',
  [AborCities.Lockhart]: 'Lockhart',
  [AborCities.Loebau]: 'Loebau',
  [AborCities.Lometa]: 'Lometa',
  [AborCities.LoneGrove]: 'Lone Grove',
  [AborCities.LoneStar]: 'Lone Star',
  [AborCities.Luckenbach]: 'Luckenbach',
  [AborCities.Luling]: 'Luling',
  [AborCities.Lund]: 'Lund',
  [AborCities.LyttonSprings]: 'Lytton Springs',
  [AborCities.Maha]: 'Maha',
  [AborCities.Mahomet]: 'Mahomet',
  [AborCities.Manchaca]: 'Manchaca',
  [AborCities.Manda]: 'Manda',
  [AborCities.Manheim]: 'Manheim',
  [AborCities.Manor]: 'Manor',
  [AborCities.MarbleFalls]: 'Marble Falls',
  [AborCities.Marion]: 'Marion',
  [AborCities.Marjorie]: 'Marjorie',
  [AborCities.MarshallFord]: 'Marshall Ford',
  [AborCities.Martindale]: 'Martindale',
  [AborCities.Maurin]: 'Maurin',
  [AborCities.Maxdale]: 'Maxdale',
  [AborCities.Maxwell]: 'Maxwell',
  [AborCities.Maysfield]: 'Maysfield',
  [AborCities.McDade]: 'McDade',
  [AborCities.McMahan]: 'McMahan',
  [AborCities.McMillan]: 'McMillan',
  [AborCities.McNairVillage]: 'McNair Village',
  [AborCities.McNeil]: 'McNeil',
  [AborCities.McQueeney]: 'McQueeney',
  [AborCities.MeadorGrove]: 'Meador Grove',
  [AborCities.Meadowlakes]: 'Meadowlakes',
  [AborCities.Meeks]: 'Meeks',
  [AborCities.Mendoza]: 'Mendoza',
  [AborCities.Merrelltown]: 'Merrelltown',
  [AborCities.Midway]: 'Midway',
  [AborCities.Milano]: 'Milano',
  [AborCities.Milburn]: 'Milburn',
  [AborCities.Minerva]: 'Minerva',
  [AborCities.Moffat]: 'Moffat',
  [AborCities.Moline]: 'Moline',
  [AborCities.Montopolis]: 'Montopolis',
  [AborCities.Moody]: 'Moody',
  [AborCities.MooresCrossing]: 'Moores Crossing',
  [AborCities.Moravia]: 'Moravia',
  [AborCities.MorgansPointResort]: "Morgan's Point Resort",
  [AborCities.MorrisFalls]: 'Morris Falls',
  [AborCities.MorrisRanch]: 'Morris Ranch',
  [AborCities.Moulton]: 'Moulton',
  [AborCities.MountainCity]: 'Mountain City',
  [AborCities.MountySharp]: 'Mounty Sharp',
  [AborCities.Mozo]: 'Mozo',
  [AborCities.MtGainor]: 'Mt Gainor',
  [AborCities.Muehlsville]: 'Muehlsville',
  [AborCities.Muldoon]: 'Muldoon',
  [AborCities.MullinsPrairie]: 'Mullins Prairie',
  [AborCities.MustangRidge]: 'Mustang Ridge',
  [AborCities.Naruna]: 'Naruna',
  [AborCities.Nassau]: 'Nassau',
  [AborCities.Nechanitz]: 'Nechanitz',
  [AborCities.Needa]: 'Needa',
  [AborCities.NewBerlin]: 'New Berlin',
  [AborCities.NewBraunfels]: 'New Braunfels',
  [AborCities.NewClarkson]: 'New Clarkson',
  [AborCities.NewColony]: 'New Colony',
  [AborCities.NewCornHill]: 'New Corn Hill',
  [AborCities.NewKaty]: 'New Katy',
  [AborCities.NewSweden]: 'New Sweden',
  [AborCities.Nickel]: 'Nickel',
  [AborCities.Niederwald]: 'Niederwald',
  [AborCities.Nile]: 'Nile',
  [AborCities.Nix]: 'Nix',
  [AborCities.Nixon]: 'Nixon',
  [AborCities.Noack]: 'Noack',
  [AborCities.Nolanville]: 'Nolanville',
  [AborCities.Nolte]: 'Nolte',
  [AborCities.NormansCrossing]: 'Normans Crossing',
  [AborCities.Northcliff]: 'Northcliff',
  [AborCities.Northrup]: 'Northrup',
  [AborCities.Noxvill]: 'Noxvill',
  [AborCities.OakForest]: 'Oak Forest',
  [AborCities.OakHill]: 'Oak Hill',
  [AborCities.Oakalla]: 'Oakalla',
  [AborCities.Oatmeal]: 'Oatmeal',
  [AborCities.Ocker]: 'Ocker',
  [AborCities.Oenaville]: 'Oenaville',
  [AborCities.Ogden]: 'Ogden',
  [AborCities.OldDimeBox]: 'Old Dime Box',
  [AborCities.Oldenburg]: 'Oldenburg',
  [AborCities.Olmos]: 'Olmos',
  [AborCities.Oquinn]: 'Oquinn',
  [AborCities.Oscar]: 'Oscar',
  [AborCities.Other]: 'Other',
  [AborCities.Ottine]: 'Ottine',
  [AborCities.OwlCreek]: 'Owl Creek',
  [AborCities.Paige]: 'Paige',
  [AborCities.Payton]: 'Payton',
  [AborCities.PecanSprings]: 'Pecan Springs',
  [AborCities.Pendleton]: 'Pendleton',
  [AborCities.Pettibone]: 'Pettibone',
  [AborCities.Pettytown]: 'Pettytown',
  [AborCities.Pflugerville]: 'Pflugerville',
  [AborCities.Phelan]: 'Phelan',
  [AborCities.PilotKnob]: 'Pilot Knob',
  [AborCities.PioneerTown]: 'Pioneer Town',
  [AborCities.PleasantValley]: 'Pleasant Valley',
  [AborCities.Plum]: 'Plum',
  [AborCities.PointVenture]: 'Point Venture',
  [AborCities.Pontotoc]: 'Pontotoc',
  [AborCities.PostOak]: 'Post Oak',
  [AborCities.Praesel]: 'Praesel',
  [AborCities.PrahaRabbsPrairie]: 'Praha Rabbs Prairie',
  [AborCities.PrairieDell]: 'Prairie Dell',
  [AborCities.PrairieLea]: 'Prairie Lea',
  [AborCities.PrairieMountain]: 'Prairie Mountain',
  [AborCities.RadioJunction]: 'Radio Junction',
  [AborCities.Ratibor]: 'Ratibor',
  [AborCities.Ratler]: 'Ratler',
  [AborCities.RedBluffCrossing]: 'Red Bluff Crossing',
  [AborCities.RedRanger]: 'Red Ranger',
  [AborCities.RedRock]: 'Red Rock',
  [AborCities.Redwood]: 'Redwood',
  [AborCities.Reedville]: 'Reedville',
  [AborCities.RiceSchoolCrossing]: 'Rice School Crossing',
  [AborCities.RicesCrossing]: 'Rices Crossing',
  [AborCities.RichlandSprings]: 'Richland Springs',
  [AborCities.RiggsFord]: 'Riggs Ford',
  [AborCities.RiversHill]: 'Rivers Hill',
  [AborCities.Rochelle]: 'Rochelle',
  [AborCities.Rockdale]: 'Rockdale',
  [AborCities.Rockne]: 'Rockne',
  [AborCities.RockyCreek]: 'Rocky Creek',
  [AborCities.RockyHill]: 'Rocky Hill',
  [AborCities.Rogers]: 'Rogers',
  [AborCities.Rollingwood]: 'Rollingwood',
  [AborCities.Rosanky]: 'Rosanky',
  [AborCities.Rosebud]: 'Rosebud',
  [AborCities.RoughCreekCrossing]: 'Rough Creek Crossing',
  [AborCities.RoundMountain]: 'Round Mountain',
  [AborCities.RoundRock]: 'Round Rock',
  [AborCities.RoundTop]: 'Round Top',
  [AborCities.Rumley]: 'Rumley',
  [AborCities.Rutersville]: 'Rutersville',
  [AborCities.Salado]: 'Salado',
  [AborCities.Salty]: 'Salty',
  [AborCities.SanAntonio]: 'San Antonio',
  [AborCities.SanGabriel]: 'San Gabriel',
  [AborCities.SanLeanna]: 'San Leanna',
  [AborCities.SanMarcos]: 'San Marcos',
  [AborCities.SanSaba]: 'San Saba',
  [AborCities.Sandoval]: 'Sandoval',
  [AborCities.Sandow]: 'Sandow',
  [AborCities.Sandy]: 'Sandy',
  [AborCities.SandyCreek]: 'Sandy Creek',
  [AborCities.SandyFork]: 'Sandy Fork',
  [AborCities.SantaClara]: 'Santa Clara',
  [AborCities.Sattle]: 'Sattle',
  [AborCities.Saturn]: 'Saturn',
  [AborCities.Sayersville]: 'Sayersville',
  [AborCities.Schertz]: 'Schertz',
  [AborCities.Schulenburg]: 'Schulenburg',
  [AborCities.Schumannsville]: 'Schumannsville',
  [AborCities.Schwertner]: 'Schwertner',
  [AborCities.Scobee]: 'Scobee',
  [AborCities.ScottsCrossing]: 'Scotts Crossing',
  [AborCities.Seaton]: 'Seaton',
  [AborCities.Seawillow]: 'Seawillow',
  [AborCities.Seguin]: 'Seguin',
  [AborCities.Selma]: 'Selma',
  [AborCities.Selman]: 'Selman',
  [AborCities.Senterfitt]: 'Senterfitt',
  [AborCities.Serbin]: 'Serbin',
  [AborCities.SewardJunction]: 'Seward Junction',
  [AborCities.ShadyGrove]: 'Shady Grove',
  [AborCities.Sharp]: 'Sharp',
  [AborCities.Shelby]: 'Shelby',
  [AborCities.SherwoodShores]: 'Sherwood Shores',
  [AborCities.Shortall]: 'Shortall',
  [AborCities.Siloam]: 'Siloam',
  [AborCities.SilverCity]: 'Silver City',
  [AborCities.Skeeterville]: 'Skeeterville',
  [AborCities.Skyview]: 'Skyview',
  [AborCities.Sloan]: 'Sloan',
  [AborCities.Smiley]: 'Smiley',
  [AborCities.Smithville]: 'Smithville',
  [AborCities.Smithwick]: 'Smithwick',
  [AborCities.SodaSprings]: 'Soda Springs',
  [AborCities.Solms]: 'Solms',
  [AborCities.SommersMill]: 'Sommers Mill',
  [AborCities.SouthElm]: 'South Elm',
  [AborCities.SouthJonestownHills]: 'South Jonestown Hills',
  [AborCities.Sparks]: 'Sparks',
  [AborCities.SparksCrossing]: 'Sparks Crossing',
  [AborCities.Spicewood]: 'Spicewood',
  [AborCities.SpringBranch]: 'Spring Branch',
  [AborCities.SpringCreek]: 'Spring Creek',
  [AborCities.Sprinkle]: 'Sprinkle',
  [AborCities.StJohnColony]: 'St John Colony',
  [AborCities.Stairtown]: 'Stairtown',
  [AborCities.Stampede]: 'Stampede',
  [AborCities.Staples]: 'Staples',
  [AborCities.Startzville]: 'Startzville',
  [AborCities.Stellar]: 'Stellar',
  [AborCities.Stolz]: 'Stolz',
  [AborCities.Stonewall]: 'Stonewall',
  [AborCities.StringPrairie]: 'String Prairie',
  [AborCities.Stringtown]: 'Stringtown',
  [AborCities.Structure]: 'Structure',
  [AborCities.Sudduth]: 'Sudduth',
  [AborCities.Summerville]: 'Summerville',
  [AborCities.Sunnyland]: 'Sunnyland',
  [AborCities.SunriseBeach]: 'Sunrise Beach',
  [AborCities.SunsetValley]: 'Sunset Valley',
  [AborCities.SweetHome]: 'Sweet Home',
  [AborCities.Tanglewood]: 'Tanglewood',
  [AborCities.Tarrytown]: 'Tarrytown',
  [AborCities.Taylor]: 'Taylor',
  [AborCities.Taylorsville]: 'Taylorsville',
  [AborCities.Temple]: 'Temple',
  [AborCities.TheGrove]: 'The Grove',
  [AborCities.TheHills]: 'The Hills',
  [AborCities.Theon]: 'Theon',
  [AborCities.Thompsonville]: 'Thompsonville',
  [AborCities.Thorndale]: 'Thorndale',
  [AborCities.Thrall]: 'Thrall',
  [AborCities.ThreePoints]: 'Three Points',
  [AborCities.Tilmon]: 'Tilmon',
  [AborCities.Tivydale]: 'Tivydale',
  [AborCities.Togo]: 'Togo',
  [AborCities.Topsey]: 'Topsey',
  [AborCities.Tow]: 'Tow',
  [AborCities.Tracy]: 'Tracy',
  [AborCities.TravisHeights]: 'Travis Heights',
  [AborCities.Troy]: 'Troy',
  [AborCities.Tunis]: 'Tunis',
  [AborCities.Turnersville]: 'Turnersville',
  [AborCities.TwinSisters]: 'Twin Sisters',
  [AborCities.Type]: 'Type',
  [AborCities.Uhland]: 'Uhland',
  [AborCities.UnionHill]: 'Union Hill',
  [AborCities.Upton]: 'Upton',
  [AborCities.Utley]: 'Utley',
  [AborCities.ValVerde]: 'Val Verde',
  [AborCities.ValleySpring]: 'Valley Spring',
  [AborCities.Vilas]: 'Vilas',
  [AborCities.VillageofBearCreek]: 'Village of Bear Creek',
  [AborCities.VillageoftheHills]: 'Village of the Hills',
  [AborCities.Volente]: 'Volente',
  [AborCities.Waelder]: 'Waelder',
  [AborCities.Walburg]: 'Walburg',
  [AborCities.Waldeck]: 'Waldeck',
  [AborCities.Walhalla]: 'Walhalla',
  [AborCities.WalkerVillage]: 'Walker Village',
  [AborCities.Walkerton]: 'Walkerton',
  [AborCities.WardSpring]: 'Ward Spring',
  [AborCities.Warda]: 'Warda',
  [AborCities.Warrenton]: 'Warrenton',
  [AborCities.Waterloo]: 'Waterloo',
  [AborCities.Watson]: 'Watson',
  [AborCities.Watterson]: 'Watterson',
  [AborCities.Webberville]: 'Webberville',
  [AborCities.Weinert]: 'Weinert',
  [AborCities.Weir]: 'Weir',
  [AborCities.WestCliff]: 'West Cliff',
  [AborCities.WestLakeHills]: 'West Lake Hills',
  [AborCities.WestPoint]: 'West Point',
  [AborCities.WhiteHall]: 'White Hall',
  [AborCities.Whitestone]: 'Whitestone',
  [AborCities.Willman]: 'Willman',
  [AborCities.WillowCity]: 'Willow City',
  [AborCities.Wimberley]: 'Wimberley',
  [AborCities.Winchester]: 'Winchester',
  [AborCities.Woodcreek]: 'Woodcreek',
  [AborCities.Woodland]: 'Woodland',
  [AborCities.WuthrichHill]: 'Wuthrich Hill',
  [AborCities.Yarrelton]: 'Yarrelton',
  [AborCities.Youngsport]: 'Youngsport',
  [AborCities.Zabcikville]: 'Zabcikville',
  [AborCities.Zipp]: 'Zipp',
  [AborCities.Zorn]: 'Zorn',
  [AborCities.Zuehl]: 'Zuehl'
};
